import React from 'react'

/**
 * Hook telling the position of center of element related to viewport.
 * It works correctly only for elements outside of viewport
 */
export default function useElementViewportPosition(ref: React.RefObject<Element | null>) {
  const box = ref.current ? ref.current.getBoundingClientRect() : { top: 0, bottom: 0, left: 0, right: 0 }
  const centerX = (box.left + box.right) / 2
  const centerY = (box.top + box.bottom) / 2
  const ifLeft = window.screenX > centerX
  const ifTop = window.screenY > centerY

  return { x: ifLeft ? 'left' : 'right', y: ifTop ? 'top' : 'bottom' }
}
